<div class="mcc-color-picker-selector" [ngStyle]="{ 'height.px': selectorHeight }">
    <div #block class="mcc-picker-selector" [style.height.px]="selectorHeight" [style.width.px]="selectorWidth"></div>
    <canvas #blockCanvas [height]="selectorHeight" [width]="selectorWidth" id="picker"></canvas>
    <div #blockPointer class="mcc-picker-position" style="top: 0px;left: 220px;"></div>

    <div #stripContainer class="mcc-colors-position" [style.height.px]="selectorHeight" [ngClass]="{'alpha-enabled': showAlphaSelector}"
         style="background-position-y: 0px;">
        <canvas #strip [height]="stripHeight" [width]="stripWidth" id="colors"></canvas>
    </div>


    <div *ngIf="showAlphaSelector" #alphaContainer class="mcc-alpha-position" [style.height.px]="selectorHeight" style="background-position-y: 0px;">
        <canvas #alpha [height]="stripHeight" [width]="stripWidth" id="alpha"></canvas>
    </div>

</div>

<div class="mcc-color-picker-selector-preview" [style.background]="tmpSelectedColor$ | async">
    <ng-container *ngIf="!hideHexForms">
        <form [formGroup]="hexForm">
            <mat-form-field class="hex-input" floatLabel="always" [ngClass]="textClass">
                <input matInput placeholder="HEX" maxlength="7" formControlName="hexCode" />
            </mat-form-field>
        </form>

        <form [formGroup]="rgbForm">
            <mat-form-field class="rgb-input" floatLabel="always" [ngClass]="textClass">
                <input matInput type="number" placeholder="RGBA" maxlength="3" formControlName="R" />
            </mat-form-field>
            <mat-form-field class="rgb-input" floatLabel="always" [ngClass]="textClass">
                <input matInput type="number" maxlength="3" formControlName="G" />
            </mat-form-field>
            <mat-form-field class="rgb-input" floatLabel="always" [ngClass]="textClass">
                <input matInput type="number" maxlength="3" formControlName="B" />
            </mat-form-field>

            <ng-container *ngIf="showAlphaSelector">
                <mat-form-field class="rgb-input" floatLabel="always" [ngClass]="textClass">
                  <input matInput type="number" maxlength="3" formControlName="A" />
                </mat-form-field>
            </ng-container>
        </form>
    </ng-container>
</div>
